module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_add-to-unscopables.js
// module id = 574
// module chunks = 0